
import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const NewsFeedSection: React.FC = () => {
  return (
    <Card className="neo-card overflow-hidden border border-neon-blue/20 shadow-lg bg-white/5 h-full">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2">
          <Zap className="h-5 w-5 text-neon-blue" />
          Latest Updates
        </CardTitle>
        <CardDescription>News and platform updates</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="p-3 rounded-lg border border-neon-blue/10 bg-black/40">
          <span className="text-xs text-neon-blue">NEW FEATURE</span>
          <h3 className="font-medium mt-1">AI Songwriting Assistant</h3>
          <p className="text-sm text-gray-400 mt-1">
            Our new AI tool helps you overcome writer's block.
          </p>
          <div className="mt-1">
            <Button variant="ghost" size="sm" className="p-0 h-auto text-sm text-neon-blue hover:text-neon-blue/80">
              Try it now →
            </Button>
          </div>
        </div>
        
        <div className="p-3 rounded-lg border border-neon-blue/10 bg-black/40">
          <span className="text-xs text-neon-blue">INDUSTRY NEWS</span>
          <h3 className="font-medium mt-1">Royalty Rates Increased</h3>
          <p className="text-sm text-gray-400 mt-1">
            Major platforms announced a 5% increase in payouts.
          </p>
          <div className="mt-1">
            <Button variant="ghost" size="sm" className="p-0 h-auto text-sm text-neon-blue hover:text-neon-blue/80">
              Read more →
            </Button>
          </div>
        </div>
        
        <Button variant="outline" size="sm" className="w-full border-neon-blue/30 text-neon-blue hover:bg-neon-blue/10 mt-1" asChild>
          <Link to="/learning?tab=news" className="flex items-center justify-center gap-1">
            View All Updates
            <ArrowRight className="h-3 w-3" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
};

export default NewsFeedSection;
